
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/usr/src/app/ui/features/discussion-topic/jst/-reply-attachment';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing;


  buffer += "<li>\n  <label class=\"screenreader-only\" for=\"attachment_";
  if (helper = helpers.uniqid) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.uniqid); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("discussions.reply_attachment")
  },data:data},helper ? helper.call(depth0, "discussions.reply_attachment.attachment_label", "Attachment", options) : helperMissing.call(depth0, "t", "discussions.reply_attachment.attachment_label", "Attachment", options)))
    + "</label>\n  <input name=\"attachment\" type=\"file\" id=\"attachment_";
  if (helper = helpers.uniqid) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.uniqid); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n  <a href=\"#\" class='discussion-reply-action' data-event=\"removeReplyAttachment\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("discussions.reply_attachment")
  },data:data},helper ? helper.call(depth0, "discussions.reply_attachment.remove_attachment", "remove", options) : helperMissing.call(depth0, "t", "discussions.reply_attachment.remove_attachment", "remove", options)))
    + "</a>\n</li>\n";
  return buffer;
  });
    
      Handlebars.registerPartial('ui/features/discussion_topic/jst/_reply_attachment.handlebars', templates['/usr/src/app/ui/features/discussion-topic/jst/-reply-attachment']);
    ;
    ;
    export default templates[name];
  